import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import PhoneCodeInputStore from './store';
import PhoneInput from '../../components/phone-input';
import TinyInput from '../../components/tiny-input';
import SmsCodeInput from '../../components/sms-code-input';
const styles = require('./index.less');

const PhoneCodeInput = ({ store }) => {
  store.use();
  return (
    <div className={styles.container}>
      <div className="validate-group-9" data-name="组 8">
        <div className="validate-layer-21" data-name="图层 40">
          <PhoneInput placeholder="请输入手机号" store={store.phoneInputStore} className={styles.phoneInput} />
        </div>
      </div>
      <div className="validate-group-10" data-name="组 7">
        <div className="validate-layer-24" data-name="图层 41">
          <TinyInput placeholder="请输入验证码" store={store.smsInputStore} className={styles.codeInput} />
        </div>
        <div className="validate-group-11" data-name="组 6">
          <SmsCodeInput codeBtnClassName={styles.codeBtn} phone={store.phoneInputStore.value} buttonText={'发送验证码'} sendCode={store.onSendVCRequest} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(PhoneCodeInput, PhoneCodeInputStore);
